import * as services from "@/services/services";
import {ILogin, IRegister, IReset, ISendReset, IValidate} from "@/models/loginModels";
import {IUserData, ILoginResponse} from "@/models/ApiModels";
import {i18n} from "@/main";

export const logout = () => {
  services.authService.clearToken();
};


export const login = (bodyData: ILogin) => { // email: string, password: string) => {
  return services.apiCaller.POST("/login", bodyData)
    .then((result: IUserData) => {
      localStorage.setItem('has-logged-once', 'yes');
      return result;
    });
};

export const register = (bodyData: IRegister) => {
  return services.apiCaller.POST("/register", bodyData)
    .then((result: IUserData) => {
      localStorage.setItem('has-logged-once', 'yes');
      return result;
    });
};

export const registerWithVCode = (bodyData: IRegister) => {
  return services.apiCaller.POST("/registerWithCode", bodyData)
    .then((result: IUserData) => {
      localStorage.setItem('has-logged-once', 'yes');
      return result;
    });
};

export const refreshUserData = () => {
  return services.apiCaller.GET("/user")
    .then((result: IUserData) => {
      localStorage.setItem('has-logged-once', 'yes');
      return result;
    });
};

export const sendResetSms = (bodyData: ISendReset) => {
  return services.apiCaller.POST("/sendResetSms", bodyData);
};


export const resetPassword = (bodyData: IReset) => {
  return services.apiCaller.POST("/resetPsw", bodyData);
};

export const validate = (bodyData: IValidate) => {
  return services.apiCaller.POST("/verification", bodyData);
};

export const sendVerificationSms = (phone: string) => services.apiCaller.POST("/resendVerification/" + phone);
export const sendPhoneRegisterSms = (phone: string) => services.apiCaller.POST("/resendPhoneRegisterSms/" + phone);


